jQuery(function($) {
    var modal = $('#kmumv-report-modal');
    var messageContainer = $('#kmumv-form-message');
    var submitButton = $('.kmumv-submit-report-form');
    var settings = window.kmumvSentToJs || {};
    var labels = settings.labels || {};

    function getLabel(key, fallback) {
        return labels[key] || fallback;
    }

    function getSelectedIds() {
        var ids = [];
        $('.kmumv-report-checkbox:checked').each(function() {
            ids.push($(this).val());
        });
        return ids;
    }

    function renderMessage(message, type) {
        var color = type === 'error' ? '#c0392b' : '#1a7f37';
        messageContainer.empty().append($('<p>').css('color', color).text(message));
    }

    function renderDownloadLinks(files) {
        if (!Array.isArray(files) || !files.length) {
            return '';
        }

        var output = $('<div>').addClass('kmumv-report-download-links');
        output.append($('<strong>').text(getLabel('download_heading', 'Download your reports:')));
        output.append('<br>');

        files.forEach(function(file) {
            output.append(
                $('<a>')
                    .addClass('kmumv-primary-btn-small')
                    .attr({
                        href: file.url,
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        download: '',
                    })
                    .text(file.title)
            );
        });

        return output;
    }

    function openModal(ids) {
        $('#kmumv-selected-ids').val(Array.isArray(ids) ? ids.join(',') : ids);
        messageContainer.empty();
        modal.show();
    }

    $('#kmumv-select-all-reports').on('change', function() {
        $('.kmumv-report-checkbox').prop('checked', $(this).prop('checked'));
    });

    $('.kmumv-get-selected-reports').on('click', function() {
        var selected = getSelectedIds();

        if (!selected.length) {
            renderMessage(getLabel('select_report_error', 'Please select at least one report.'), 'error');
            return;
        }

        openModal(selected);
    });

    $('.kmumv-get-report-single').on('click', function(event) {
        event.preventDefault();
        openModal($(this).data('id'));
    });

    $('.kmumv-close-modal').on('click', function() {
        modal.hide();
    });

    $(window).on('click', function(event) {
        if (event.target === modal[0]) {
            modal.hide();
        }
    });

    $('#kmumv-report-subscribe-form').on('submit', function(event) {
        event.preventDefault();

        var firstName = $(this).find('input[name="first_name"]').val();
        var lastName = $(this).find('input[name="last_name"]').val();
        var email = $(this).find('input[name="user_email"]').val();
        var reportIds = $('#kmumv-selected-ids').val();

        if (!firstName || !lastName || !email || !reportIds) {
            renderMessage(getLabel('required_fields_error', 'Please fill out your name, email, and selected reports.'), 'error');
            return;
        }

        submitButton.prop('disabled', true);
        renderMessage(getLabel('processing_message', 'Processing your subscription... Please wait.'), 'info');

        $.post(settings.ajaxUrl, {
            action: 'kmumv_subscribe_reports',
            _wpnonce: settings.nonce,
            first_name: firstName,
            last_name: lastName,
            user_email: email,
            selected_report_ids: reportIds,
        }).done(function(response) {
            if (response.success) {
                messageContainer
                    .empty()
                    .append($('<p>').text(response.data.message))
                    .append(renderDownloadLinks(response.data.download_files));
            } else {
                var message = response.data && response.data.message ? response.data.message : getLabel('generic_error', 'An unexpected error occurred. Please try again.');
                renderMessage(message, 'error');
            }
        }).fail(function(xhr) {
            var message = getLabel('request_failed_error', 'Unable to submit your request. Please try again later.');
            if (xhr.responseJSON && xhr.responseJSON.data && xhr.responseJSON.data.message) {
                message = xhr.responseJSON.data.message;
            }
            renderMessage(message, 'error');
        }).always(function() {
            submitButton.prop('disabled', false);
        });
    });
});
